"use client";
import React, { useMemo, useState } from "react";
import classnames from "classnames";
import { commonStore, getQuestion } from "@/store";
import { getSiteConfiguration } from "@/src/utils/configUtils";
import stl from "./writeQuestionsForm.module.scss";
import {
    FmButton,
    FmCheckbox,
    FmRadio,
    FmTextArea,
    IFormLabel,
} from "@/ui-component";
import { FormikHelpers } from "formik";
interface IProps<T> {
    setFieldValue: FormikHelpers<T>["setFieldValue"];
    values: IValue<T>;
}

type IValue<T> = Record<keyof T, any>;
const showMore = "Show more",
    showFewer = "Show fewer";
function WriteQuestionsForm<T extends Record<string, any>>(props: IProps<T>) {
    const { setFieldValue, values } = props;
    const [questions] = getQuestion.useGetQuestionsStore((state) => [
        state.questions,
    ]);

    const [domain] = commonStore.useCommonStore((state) => [state.domain]);
    const [text, setText] = useState(showMore);

    const questionDom = useMemo(() => {
        return questions.map((item, index) => {
            const isCheckbox = item.choose === 2; // checkbox || radio
            const answer = item.answer;
            const checkboxData: IFormLabel<string | number>[] = [];
            answer.map((data: any, index: number) => {
                checkboxData.push({
                    value: data,
                    label: data,
                    checkboxName: item.tag,
                    formControlLabelClassName: stl["checkbox-or-radio-item"],
                });
            });
            const expand =
                item.expand === 1 && !isCheckbox && values[item.tag] === "No";
            if (!expand && values[item.expand_key]) {
                //选择No 过后增加一个输入框。不要问为什么选No ,不要问为什么要判断这个字符串？我也不知道为什么，后端让我这样判断的，我也很懵逼，争论无效。
                setFieldValue(item.expand_key, "");
            }

            const boxOfDiffType = isCheckbox ? (
                <div style={{ marginTop: "0.4rem" }}>
                    <FmCheckbox
                        dataSource={checkboxData}
                        values={values[item.tag]}
                        onChange={(values) => setFieldValue(item.tag, values)}
                    />
                </div>
            ) : (
                <FmRadio
                    dataSource={checkboxData}
                    value={values[item.tag]}
                    type="circle"
                    className={classnames(stl["answer-radio"], "answer-radio")}
                    onChange={(e, val) => setFieldValue(item.tag, val)}
                />
            );

            return (
                <div key={item.answer} className={stl["questionsList"]}>
                    <div className={stl["question-item"]}>
                        {index + 1}.{" "}
                        <span
                            dangerouslySetInnerHTML={{
                                __html: item.qustion.replace(
                                    "Firmoo",
                                    getSiteConfiguration("siteName", domain),
                                ),
                            }}
                        />
                    </div>
                    {/* 替换checkboxRadios */}
                    {answer.length > 0 ? (
                        boxOfDiffType
                    ) : (
                        <FmTextArea
                            rows={5}
                            name={item.tag}
                            value={values[item.tag]}
                            onChange={(e) =>
                                setFieldValue(item.tag, e.target.value)
                            }
                            className={classnames(
                                stl["review-text-input"],

                            )}
                            InputProps={{
                                classes: {
                                    root: stl["input-props-root"],
                                },
                            }}
                            FormHelperTextProps={{
                                classes: {
                                    error: stl[
                                        "input-form-help-text-error"
                                    ],
                                },
                            }}
                        />
                    )}
                    {expand && (
                        <div>
                            <FmTextArea
                                rows={5}
                                className={classnames(
                                    stl["questionsListInputText"],
                                )}
                                value={values[item.tag]}
                                placeholder={
                                    "We would be grateful if you could tell us why you don't like to recommend Firmoo."
                                }
                                // defaultValue={this.state[item.expand_key]} // TODO: 这个是什么
                                name={item.expand_key}
                                onChange={(e) => {
                                    setFieldValue(
                                        item.expand_key,
                                        e.target.value,
                                    );
                                }}
                            />
                        </div>
                    )}
                </div>
            );
        });
    }, [domain, questions, setFieldValue, values]);

    return (
        <div
            className={classnames(stl["WriteQuestionsForm"], {
                [stl["hover"]]: text === showFewer,
            })}
        >
            {questionDom}
            <FmButton
                onClick={(e) =>
                    setText(text === showMore ? showFewer : showMore)
                }
                className={classnames(stl["show-more"], {
                    ["hidden"]: questions.length > 2,
                })}
                variant={"text"}
            >
                {text}
                {">>"}
            </FmButton>
        </div>
    );
}

export default WriteQuestionsForm;
